
export default function HeroSection() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/da509e43120d6c596d33cc9ae1e97841.jpg"
          alt="全球物流解决方案"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <p className="text-teal-300 text-base font-medium tracking-widest mb-4 uppercase animate-fade-in">
          值得信赖的国际物流伙伴
        </p>
        <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          全球物流解决方案
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto">
          专业国际货运代理、仓储管理及供应链解决方案，助力您的业务通达全球
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#services"
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            了解服务
          </a>
          <a
            href="#contact"
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            联系我们
          </a>
        </div>
      </div>
    </section>
  );
}
